import React from 'react';

const ImportantDate = ({ date_info, sl, linkable }) => {

    return (
        <div>
            <a
                className="text-decoration-none primary-text"
                target="_blank"
                href={date_info?.pdf_link?.url || date_info?.link}
            > <p className=" m-0 p-0">{sl}. {date_info.info[0]?.text}</p>
            </a>
        </div>
    );
};

export default ImportantDate;